import React from 'react';

const chargeTypes = [
  { id: 'SHIPPING_CHARGE', label: 'Delivery Charge' },
  { id: 'LATE_NIGHT_FEE', label: 'Late Night Delivery Charge' },
  { id: 'RETURN_CHARGES', label: 'Return Charges' },
  { id: 'COD_CHARGE', label: 'COD Charge' },
  { id: 'custom', label: 'Custom Charge' }
];

function AdditionalChargesSection({
                                    charges,
                                    newCharge,
                                    onNewChargeChange,
                                    onAddCharge,
                                    onUpdateCharge,
                                    onRemoveCharge
                                  }) {
  return (
      <div className="bg-gray-50 rounded-lg p-4 mt-6 space-y-4">
        <h3 className="text-lg font-semibold text-gray-700">Additional Charges</h3>

        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Charge Type
            </label>
            <select
                className="input-field"
                value={newCharge.type}
                onChange={(e) => onNewChargeChange({ ...newCharge, type: e.target.value })}
            >
              {chargeTypes.map(type => (
                  <option key={type.id} value={type.id}>
                    {type.label}
                  </option>
              ))}
            </select>
          </div>

          {newCharge.type === 'custom' && (
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Charge Name
                </label>
                <input
                    type="text"
                    className="input-field"
                    value={newCharge.name}
                    onChange={(e) => onNewChargeChange({ ...newCharge, name: e.target.value })}
                    placeholder="Enter charge name"
                />
              </div>
          )}

          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Amount
            </label>
            <div className="flex items-center">
              <span className="text-gray-600 mr-2">₹</span>
              <input
                  type="number"
                  min="0"
                  className="input-field"
                  value={newCharge.amount}
                  onChange={(e) => onNewChargeChange({ ...newCharge, amount: e.target.value })}
              />
            </div>
          </div>

          <button
              onClick={onAddCharge}
              className="btn-secondary h-[42px]"
          >
            Add Charge
          </button>
        </div>

        <div className="space-y-2 mt-4">
          {charges.map(charge => (
              <div key={charge.id} className="flex items-center justify-between bg-white p-3 rounded-lg">
                <span className="font-medium">{charge.name}</span>
                <div className="flex items-center gap-3">
                  <div className="flex items-center">
                    <span className="text-gray-600 mr-2">₹</span>
                    <input
                        type="number"
                        min="0"
                        className="input-field w-32"
                        value={charge.amount}
                        onChange={(e) => onUpdateCharge(charge.id, e.target.value)}
                    />
                  </div>
                  <button
                      onClick={() => onRemoveCharge(charge.id)}
                      className="text-red-600 hover:text-red-800"
                  >
                    Remove
                  </button>
                </div>
              </div>
          ))}
        </div>
      </div>
  );
}

export default AdditionalChargesSection; 